import { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const roleService = {
    getAll,
    getAllPermissions,
    save,
    get,
    deleteRole,
    updateRole,
    getAllNoPagination
};

function getAll(data)
{
    return axios.get('/api/services/app/Role/GetAll', {
        params: {
            Keyword: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting           
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function getAllNoPagination()
{
    return axios.get('/api/services/app/Role/GetRoles', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })    
}
function getAllPermissions()
{
    return axios.get('/api/services/app/Role/GetAllPermissions', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })    
}
function save(data)
{        
    return axios.post('/api/services/app/Role/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function updateRole(data)
{
    return axios.put('/api/services/app/Role/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })    
}
function get(id)
{
    return axios.get('/api/services/app/Role/GetRoleForEdit', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })     
}
function deleteRole(id)
{
    return axios.delete('/api/services/app/Role/Delete', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })     
}